import { Slot } from '../Slot';
import { SlotMapper } from './SlotMapper';

export interface SingleSlotWithParentArticleNumber {
  slot: Slot;
  parentArticleNumber: string;
}

export class SingleSlotWithParentArticleNumberMapper {
  static toDto = (
    aggregate: SingleSlotWithParentArticleNumber
  ): CoreServiceAPI.SlotInstanceInDto => ({
    parentArticleNumber: aggregate.parentArticleNumber,
    ...SlotMapper.toDto(aggregate.slot)
  });

  static from = (slot: Slot, parentArticleNumber: string): SingleSlotWithParentArticleNumber => ({
    slot,
    parentArticleNumber
  });
}
